import { render, staticRenderFns } from "./WildcardModal.vue?vue&type=template&id=07a1c330"
import script from "./WildcardModal.vue?vue&type=script&lang=js"
export * from "./WildcardModal.vue?vue&type=script&lang=js"
import style0 from "./WildcardModal.vue?vue&type=style&index=0&id=07a1c330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports